import type { IContainer } from '@monofe/di';
import { buildBindable } from '@monofe/di';
import { injectConfigLog } from '../interface/config';
import type { ILog } from '../interface/log';
import { bindLog, injectLog, unbindLog } from '../interface/log';
import TYPES from '../util/types';
import logger from './log';

function _build(container: IContainer): Readonly<ILog> {
    const config = injectConfigLog(container);

    const log = logger(config);

    return Object.freeze(log);
}

export default buildBindable<ILog>({
    id: TYPES.ILog,
    dependencies: [TYPES.IConfigLog],
    bind: bindLog,
    remove: unbindLog,
    inject: injectLog,
    build: container => Promise.resolve(_build(container)),
});
